const header = document.querySelector("#header");
const mainNav = document.querySelector("#header .main-nav");

document.querySelector(".wrapper").addEventListener("scroll", (event) => {
	if (header.offsetTop > header.offsetHeight) {
		header.classList.add('darkforest_bg');
		header.classList.remove('header-bg');
	} else {
		header.classList.remove('darkforest_bg');
		header.classList.add('header-bg');
	}
});


const body = document.getElementsByTagName('body');
const nav = document.getElementById('main-nav');
const menuToggle = document.getElementById('primary-mobile-menu');
const menu = document.getElementById('primary-menu-container');
const closeNavLink = document.querySelector('.close-nav');

menuToggle.addEventListener("click", toggleMenu);
closeNavLink.addEventListener("click", toggleMenu);

function toggleMenu() {
	console.log('clicked');
	let menuOpen = nav.classList.contains("opened");
	let newMenuOpenStatus = !menuOpen;

	menuToggle.setAttribute("aria-expanded", newMenuOpenStatus.toString());
	nav.classList.toggle("opened");
	menuToggle.classList.toggle("opened");
	body[0].classList.toggle("opened");
}
